document.addEventListener('DOMContentLoaded', function() {
  if (!window.mz) {
    return
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  function afterUpdate() {
    if (!mz.app.context.tags.includes('collection')) {
      return
    }
    let total = mz.app.hits.total
    for (let i = 0; i < mz.app.aggregations.length; i++) {
      let agg = mz.app.aggregations[i]
      if (agg.selected.length != 0) {
        continue
      } 
      if (agg.items.length == 1 && agg.items[0].count == total) {
        mz.app.aggregations[i].items = []
      }
    }
  }
  function lazyLoadItem(el, item, callback) {
    fetch(`/products/${item.handle}?view=mezereon`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const mzCardProduct = html.querySelector('#mz-card-product');
      callback(mzCardProduct.innerHTML);
    })
    .catch((e) => {
      console.error(e);
    });    
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate)
    mz.app.$bus.on('lazy-load-item', lazyLoadItem)
  }
})
